module.exports = __webpack_public_path__ + "img/fig01.11244e0e.jpg";